import React, { useRef, useState } from "react";
import FormCreator from "../../components/Forms/FormCreator";
import Buttons from "../../components/ui/button/Buttons";
import forgetPasswordFormData from "./ForgetPasswordForm.data";
import ToastService from "../../services/toastService/ToastService";
import { Link } from "react-router-dom";

const ForgetPasswordForm = () => {
  const forgetFormRef = useRef();
  const [isLoading, setIsLoading] = useState(false);

  const handleResetPassword = () => {
    const formData = forgetFormRef.current?.getFormData();
    if (!formData) return;

    setIsLoading(true);
    // Simulate reset password API request
    setTimeout(() => {
      setIsLoading(false);
      ToastService.success(
        "A password reset link has been sent to your email address.",
        "Success"
      );
    }, 1000);
  };

  return (
    <div className="login-form-section">
      <FormCreator
        ref={forgetFormRef}
        {...forgetPasswordFormData}
      />
      <div className="button-part">
        <Buttons
          buttonTypeClassName="btn success-btn"
          buttonText="Reset your password"
          onClick={handleResetPassword}
          isLoading={isLoading}
        />
      </div>
      <div className="text-center mt-3">
        <Link
          to="/login"
          className="font-medium text-[#329a03] hover:text-[#297407] text-sm"
        >
          Back to Login
        </Link>
      </div>
    </div>
  );
};

export default ForgetPasswordForm;
